export default __webpack_public_path__ + "static/media/cardiac-gray.b60573a3.svg";